/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdjustStaffCreditsHeaders,
  AiTaskList,
  AiTaskModelSet,
  AiTaskView,
  AuditPage,
  CancelStaffJobHeaders,
  CreateStaffTeamHeaders,
  DeleteStaffUserHeaders,
  ErrorEnvelope,
  FindStaffUserParams,
  GrantStaffCreditsHeaders,
  ListStaffAuditParams,
  ListStaffUsageJobsParams,
  ListStaffUsageParams,
  SetStaffAiTaskModelHeaders,
  StaffAdjustment,
  StaffAdjustmentResult,
  StaffGrantResult,
  StaffJobCancel,
  StaffJobCanceled,
  StaffLotGrant,
  StaffPlanPeriodGrant,
  StaffTeamCreate,
  StaffTeamCreated,
  StaffTeamDetail,
  StaffTeamListed,
  StaffUsageJobPage,
  StaffUsagePage,
  StaffUser,
  UsageTrace
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListStaffAiTasksUrl = () => {




  return `/api/v1/staff/ai-tasks`
}

/**
 * Every AI task (spec G9-ai-tasks): live's model, the one it runs on now and the switch
 * behind it, and each row it may run on with its price and whether it may be chosen here.
 * @summary List Staff Ai Tasks
 */
export const listStaffAiTasks = async ( options?: Parameters<typeof apiRequest>[1]): Promise<AiTaskList> => {

  return apiRequest<AiTaskList>(getListStaffAiTasksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffAiTasksQueryKey = () => {
    return [
    `/api/v1/staff/ai-tasks`
    ] as const;
    }


export const getListStaffAiTasksQueryOptions = <TData = Awaited<ReturnType<typeof listStaffAiTasks>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffAiTasksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffAiTasks>>> = ({ signal }) => listStaffAiTasks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStaffAiTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffAiTasks>>>
export type ListStaffAiTasksQueryError = ErrorType<ErrorEnvelope>


export function useListStaffAiTasks<TData = Awaited<ReturnType<typeof listStaffAiTasks>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffAiTasks>>,
          TError,
          Awaited<ReturnType<typeof listStaffAiTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffAiTasks<TData = Awaited<ReturnType<typeof listStaffAiTasks>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffAiTasks>>,
          TError,
          Awaited<ReturnType<typeof listStaffAiTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffAiTasks<TData = Awaited<ReturnType<typeof listStaffAiTasks>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Staff Ai Tasks
 */

export function useListStaffAiTasks<TData = Awaited<ReturnType<typeof listStaffAiTasks>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAiTasks>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStaffAiTasksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSetStaffAiTaskModelUrl = (taskId: string,) => {




  return `/api/v1/staff/ai-tasks/${taskId}/model`
}

/**
 * Switch the task to one of its rows, with a reason, for every start after this one.
 * 404 for an unknown task; 422 at `model` for a catalog tool, a row outside the task's,
 * one not offered here, or, in prod, one with no real run on dev.
 * @summary Set Staff Ai Task Model
 */
export const setStaffAiTaskModel = async (taskId: string,
    aiTaskModelSet: AiTaskModelSet,
    headers: SetStaffAiTaskModelHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<AiTaskView> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AiTaskView>(getSetStaffAiTaskModelUrl(taskId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(aiTaskModelSet)
  }
);}





export const getSetStaffAiTaskModelMutationKey = () => ['setStaffAiTaskModel'] as const;

export const getSetStaffAiTaskModelMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStaffAiTaskModel>>, TError,SetStaffAiTaskModelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof setStaffAiTaskModel>>, TError,SetStaffAiTaskModelMutationVariables, TContext> => {

const mutationKey = getSetStaffAiTaskModelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setStaffAiTaskModel>>, SetStaffAiTaskModelMutationVariables> = (props) => {
          const {taskId,data,headers} = props ?? {};

          return  setStaffAiTaskModel(taskId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetStaffAiTaskModelMutationResult = NonNullable<Awaited<ReturnType<typeof setStaffAiTaskModel>>>
    export type SetStaffAiTaskModelMutationBody = AiTaskModelSet
    export type SetStaffAiTaskModelMutationError = ErrorType<ErrorEnvelope>
    export type SetStaffAiTaskModelMutationVariables = {taskId: string;data: AiTaskModelSet;headers: SetStaffAiTaskModelHeaders}

    /**
 * @summary Set Staff Ai Task Model
 */
export const useSetStaffAiTaskModel = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStaffAiTaskModel>>, TError,SetStaffAiTaskModelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setStaffAiTaskModel>>,
        TError,
        SetStaffAiTaskModelMutationVariables,
        TContext
      > => {
      return useMutation(getSetStaffAiTaskModelMutationOptions(options), queryClient);
    }
    export const getListStaffAuditUrl = (params?: ListStaffAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/staff/audit?${stringifiedParams}` : `/api/v1/staff/audit`
}

/**
 * Every staff mutation, newest first.
 * @summary List Staff Audit
 */
export const listStaffAudit = async (params?: ListStaffAuditParams, options?: Parameters<typeof apiRequest>[1]): Promise<AuditPage> => {

  return apiRequest<AuditPage>(getListStaffAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffAuditQueryKey = (params?: ListStaffAuditParams,) => {
    return [
    `/api/v1/staff/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStaffAuditQueryOptions = <TData = Awaited<ReturnType<typeof listStaffAudit>>, TError = ErrorType<ErrorEnvelope>>(params?: ListStaffAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffAudit>>> = ({ signal }) => listStaffAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStaffAuditQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffAudit>>>
export type ListStaffAuditQueryError = ErrorType<ErrorEnvelope>


export function useListStaffAudit<TData = Awaited<ReturnType<typeof listStaffAudit>>, TError = ErrorType<ErrorEnvelope>>(
 params: undefined |  ListStaffAuditParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffAudit>>,
          TError,
          Awaited<ReturnType<typeof listStaffAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffAudit<TData = Awaited<ReturnType<typeof listStaffAudit>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffAudit>>,
          TError,
          Awaited<ReturnType<typeof listStaffAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffAudit<TData = Awaited<ReturnType<typeof listStaffAudit>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Staff Audit
 */

export function useListStaffAudit<TData = Awaited<ReturnType<typeof listStaffAudit>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffAudit>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStaffAuditQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListStaffTeamsUrl = () => {




  return `/api/v1/staff/teams`
}

/**
 * Every team, deleted ones too (with `deleted_at`), with its usage over its whole life:
 * the credits its jobs used, charged less refunded, and the known part of their vendor
 * cost.
 * @summary List Staff Teams
 */
export const listStaffTeams = async ( options?: Parameters<typeof apiRequest>[1]): Promise<StaffTeamListed[]> => {

  return apiRequest<StaffTeamListed[]>(getListStaffTeamsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffTeamsQueryKey = () => {
    return [
    `/api/v1/staff/teams`
    ] as const;
    }


export const getListStaffTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listStaffTeams>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffTeams>>> = ({ signal }) => listStaffTeams({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStaffTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffTeams>>>
export type ListStaffTeamsQueryError = ErrorType<ErrorEnvelope>


export function useListStaffTeams<TData = Awaited<ReturnType<typeof listStaffTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffTeams>>,
          TError,
          Awaited<ReturnType<typeof listStaffTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffTeams<TData = Awaited<ReturnType<typeof listStaffTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffTeams>>,
          TError,
          Awaited<ReturnType<typeof listStaffTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffTeams<TData = Awaited<ReturnType<typeof listStaffTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Staff Teams
 */

export function useListStaffTeams<TData = Awaited<ReturnType<typeof listStaffTeams>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffTeams>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStaffTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateStaffTeamUrl = () => {




  return `/api/v1/staff/teams`
}

/**
 * A team for an owner email: staff holds it until the owner accepts the emailed
 * invitation (for the staff user's own email, there is none).
 * @summary Create Staff Team
 */
export const createStaffTeam = async (staffTeamCreate: StaffTeamCreate,
    headers: CreateStaffTeamHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<StaffTeamCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StaffTeamCreated>(getCreateStaffTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(staffTeamCreate)
  }
);}





export const getCreateStaffTeamMutationKey = () => ['createStaffTeam'] as const;

export const getCreateStaffTeamMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaffTeam>>, TError,CreateStaffTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createStaffTeam>>, TError,CreateStaffTeamMutationVariables, TContext> => {

const mutationKey = getCreateStaffTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStaffTeam>>, CreateStaffTeamMutationVariables> = (props) => {
          const {data,headers} = props ?? {};

          return  createStaffTeam(data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStaffTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createStaffTeam>>>
    export type CreateStaffTeamMutationBody = StaffTeamCreate
    export type CreateStaffTeamMutationError = ErrorType<ErrorEnvelope>
    export type CreateStaffTeamMutationVariables = {data: StaffTeamCreate;headers: CreateStaffTeamHeaders}

    /**
 * @summary Create Staff Team
 */
export const useCreateStaffTeam = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaffTeam>>, TError,CreateStaffTeamMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStaffTeam>>,
        TError,
        CreateStaffTeamMutationVariables,
        TContext
      > => {
      return useMutation(getCreateStaffTeamMutationOptions(options), queryClient);
    }
    export const getGetStaffTeamUrl = (teamId: string,) => {




  return `/api/v1/staff/teams/${teamId}`
}

/**
 * A team's members, open invitations, balance and newest 50 ledger entries.
 * @summary Get Staff Team
 */
export const getStaffTeam = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<StaffTeamDetail> => {

  return apiRequest<StaffTeamDetail>(getGetStaffTeamUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStaffTeamQueryKey = (teamId: string,) => {
    return [
    `/api/v1/staff/teams/${teamId}`
    ] as const;
    }


export const getGetStaffTeamQueryOptions = <TData = Awaited<ReturnType<typeof getStaffTeam>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStaffTeamQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaffTeam>>> = ({ signal }) => getStaffTeam(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStaffTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getStaffTeam>>>
export type GetStaffTeamQueryError = ErrorType<ErrorEnvelope>


export function useGetStaffTeam<TData = Awaited<ReturnType<typeof getStaffTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffTeam>>,
          TError,
          Awaited<ReturnType<typeof getStaffTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStaffTeam<TData = Awaited<ReturnType<typeof getStaffTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffTeam>>,
          TError,
          Awaited<ReturnType<typeof getStaffTeam>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStaffTeam<TData = Awaited<ReturnType<typeof getStaffTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Staff Team
 */

export function useGetStaffTeam<TData = Awaited<ReturnType<typeof getStaffTeam>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffTeam>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStaffTeamQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdjustStaffCreditsUrl = (teamId: string,) => {




  return `/api/v1/staff/teams/${teamId}/adjustments`
}

/**
 * A signed correction with a reason. 402 when a debit is more than `available`.
 * @summary Adjust Staff Credits
 */
export const adjustStaffCredits = async (teamId: string,
    staffAdjustment: StaffAdjustment,
    headers: AdjustStaffCreditsHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<StaffAdjustmentResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StaffAdjustmentResult>(getAdjustStaffCreditsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(staffAdjustment)
  }
);}





export const getAdjustStaffCreditsMutationKey = () => ['adjustStaffCredits'] as const;

export const getAdjustStaffCreditsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustStaffCredits>>, TError,AdjustStaffCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustStaffCredits>>, TError,AdjustStaffCreditsMutationVariables, TContext> => {

const mutationKey = getAdjustStaffCreditsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustStaffCredits>>, AdjustStaffCreditsMutationVariables> = (props) => {
          const {teamId,data,headers} = props ?? {};

          return  adjustStaffCredits(teamId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustStaffCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof adjustStaffCredits>>>
    export type AdjustStaffCreditsMutationBody = StaffAdjustment
    export type AdjustStaffCreditsMutationError = ErrorType<ErrorEnvelope>
    export type AdjustStaffCreditsMutationVariables = {teamId: string;data: StaffAdjustment;headers: AdjustStaffCreditsHeaders}

    /**
 * @summary Adjust Staff Credits
 */
export const useAdjustStaffCredits = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustStaffCredits>>, TError,AdjustStaffCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adjustStaffCredits>>,
        TError,
        AdjustStaffCreditsMutationVariables,
        TContext
      > => {
      return useMutation(getAdjustStaffCreditsMutationOptions(options), queryClient);
    }
    export const getGrantStaffCreditsUrl = (teamId: string,) => {




  return `/api/v1/staff/teams/${teamId}/grants`
}

/**
 * Credits for a live team: a lot, or a month of a plan. 409 `TEAM_DELETED`.
 * @summary Grant Staff Credits
 */
export const grantStaffCredits = async (teamId: string,
    staffLotGrantStaffPlanPeriodGrant: StaffLotGrant | StaffPlanPeriodGrant,
    headers: GrantStaffCreditsHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<StaffGrantResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StaffGrantResult>(getGrantStaffCreditsUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(staffLotGrantStaffPlanPeriodGrant)
  }
);}





export const getGrantStaffCreditsMutationKey = () => ['grantStaffCredits'] as const;

export const getGrantStaffCreditsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantStaffCredits>>, TError,GrantStaffCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof grantStaffCredits>>, TError,GrantStaffCreditsMutationVariables, TContext> => {

const mutationKey = getGrantStaffCreditsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantStaffCredits>>, GrantStaffCreditsMutationVariables> = (props) => {
          const {teamId,data,headers} = props ?? {};

          return  grantStaffCredits(teamId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantStaffCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof grantStaffCredits>>>
    export type GrantStaffCreditsMutationBody = StaffLotGrant | StaffPlanPeriodGrant
    export type GrantStaffCreditsMutationError = ErrorType<ErrorEnvelope>
    export type GrantStaffCreditsMutationVariables = {teamId: string;data: StaffLotGrant | StaffPlanPeriodGrant;headers: GrantStaffCreditsHeaders}

    /**
 * @summary Grant Staff Credits
 */
export const useGrantStaffCredits = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantStaffCredits>>, TError,GrantStaffCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantStaffCredits>>,
        TError,
        GrantStaffCreditsMutationVariables,
        TContext
      > => {
      return useMutation(getGrantStaffCreditsMutationOptions(options), queryClient);
    }
    export const getCancelStaffJobUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/staff/teams/${teamId}/jobs/${jobId}/cancel`
}

/**
 * Stop a job that has not delivered and release its hold. 409 `JOB_FINALIZING` once
 * the provider delivered, `JOB_TERMINAL` once it ended.
 * @summary Cancel Staff Job
 */
export const cancelStaffJob = async (teamId: string,
    jobId: string,
    staffJobCancel: StaffJobCancel,
    headers: CancelStaffJobHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<StaffJobCanceled> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StaffJobCanceled>(getCancelStaffJobUrl(teamId,jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(staffJobCancel)
  }
);}





export const getCancelStaffJobMutationKey = () => ['cancelStaffJob'] as const;

export const getCancelStaffJobMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStaffJob>>, TError,CancelStaffJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelStaffJob>>, TError,CancelStaffJobMutationVariables, TContext> => {

const mutationKey = getCancelStaffJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelStaffJob>>, CancelStaffJobMutationVariables> = (props) => {
          const {teamId,jobId,data,headers} = props ?? {};

          return  cancelStaffJob(teamId,jobId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelStaffJobMutationResult = NonNullable<Awaited<ReturnType<typeof cancelStaffJob>>>
    export type CancelStaffJobMutationBody = StaffJobCancel
    export type CancelStaffJobMutationError = ErrorType<ErrorEnvelope>
    export type CancelStaffJobMutationVariables = {teamId: string;jobId: string;data: StaffJobCancel;headers: CancelStaffJobHeaders}

    /**
 * @summary Cancel Staff Job
 */
export const useCancelStaffJob = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStaffJob>>, TError,CancelStaffJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelStaffJob>>,
        TError,
        CancelStaffJobMutationVariables,
        TContext
      > => {
      return useMutation(getCancelStaffJobMutationOptions(options), queryClient);
    }
    export const getGetStaffJobTraceUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/staff/teams/${teamId}/jobs/${jobId}/trace`
}

/**
 * One job of a team down to each vendor request: its inputs, outputs and their files
 * (each URL bound to its one object, for 15 minutes), its requests with their bodies, its
 * webhooks, credits, parent and steps. Each read writes its audit row
 * (`usage.trace_read`) before it answers: 404 with none for a job of another team or none,
 * 500 with nothing when the row cannot be written.
 * @summary Get Staff Job Trace
 */
export const getStaffJobTrace = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<UsageTrace> => {

  return apiRequest<UsageTrace>(getGetStaffJobTraceUrl(teamId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStaffJobTraceQueryKey = (teamId: string,
    jobId: string,) => {
    return [
    `/api/v1/staff/teams/${teamId}/jobs/${jobId}/trace`
    ] as const;
    }


export const getGetStaffJobTraceQueryOptions = <TData = Awaited<ReturnType<typeof getStaffJobTrace>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStaffJobTraceQueryKey(teamId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaffJobTrace>>> = ({ signal }) => getStaffJobTrace(teamId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStaffJobTraceQueryResult = NonNullable<Awaited<ReturnType<typeof getStaffJobTrace>>>
export type GetStaffJobTraceQueryError = ErrorType<ErrorEnvelope>


export function useGetStaffJobTrace<TData = Awaited<ReturnType<typeof getStaffJobTrace>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffJobTrace>>,
          TError,
          Awaited<ReturnType<typeof getStaffJobTrace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStaffJobTrace<TData = Awaited<ReturnType<typeof getStaffJobTrace>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStaffJobTrace>>,
          TError,
          Awaited<ReturnType<typeof getStaffJobTrace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStaffJobTrace<TData = Awaited<ReturnType<typeof getStaffJobTrace>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Staff Job Trace
 */

export function useGetStaffJobTrace<TData = Awaited<ReturnType<typeof getStaffJobTrace>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStaffJobTrace>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStaffJobTraceQueryOptions(teamId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListStaffUsageUrl = (params?: ListStaffUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/staff/usage?${stringifiedParams}` : `/api/v1/staff/usage`
}

/**
 * Every team's usage grouped by `group_by`: user (the default), team, brand, model,
 * type or day, a run's steps under their generation. At most 500 groups, the most net
 * credits first (days newest first), the totals of all of them, and the names of the users,
 * teams or models the groups are. No prompt and no file: those are in a trace alone.
 * @summary List Staff Usage
 */
export const listStaffUsage = async (params?: ListStaffUsageParams, options?: Parameters<typeof apiRequest>[1]): Promise<StaffUsagePage> => {

  return apiRequest<StaffUsagePage>(getListStaffUsageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffUsageQueryKey = (params?: ListStaffUsageParams,) => {
    return [
    `/api/v1/staff/usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStaffUsageQueryOptions = <TData = Awaited<ReturnType<typeof listStaffUsage>>, TError = ErrorType<ErrorEnvelope>>(params?: ListStaffUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffUsage>>> = ({ signal }) => listStaffUsage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStaffUsageQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffUsage>>>
export type ListStaffUsageQueryError = ErrorType<ErrorEnvelope>


export function useListStaffUsage<TData = Awaited<ReturnType<typeof listStaffUsage>>, TError = ErrorType<ErrorEnvelope>>(
 params: undefined |  ListStaffUsageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffUsage>>,
          TError,
          Awaited<ReturnType<typeof listStaffUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffUsage<TData = Awaited<ReturnType<typeof listStaffUsage>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffUsage>>,
          TError,
          Awaited<ReturnType<typeof listStaffUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffUsage<TData = Awaited<ReturnType<typeof listStaffUsage>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Staff Usage
 */

export function useListStaffUsage<TData = Awaited<ReturnType<typeof listStaffUsage>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsage>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStaffUsageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListStaffUsageJobsUrl = (params?: ListStaffUsageJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/staff/usage/jobs?${stringifiedParams}` : `/api/v1/staff/usage/jobs`
}

/**
 * The generations behind the filters, newest start first, open ones included, each
 * with its run's totals and, with `steps`, its steps' lines; `group_by` plays no part.
 * @summary List Staff Usage Jobs
 */
export const listStaffUsageJobs = async (params?: ListStaffUsageJobsParams, options?: Parameters<typeof apiRequest>[1]): Promise<StaffUsageJobPage> => {

  return apiRequest<StaffUsageJobPage>(getListStaffUsageJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStaffUsageJobsQueryKey = (params?: ListStaffUsageJobsParams,) => {
    return [
    `/api/v1/staff/usage/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStaffUsageJobsQueryOptions = <TData = Awaited<ReturnType<typeof listStaffUsageJobs>>, TError = ErrorType<ErrorEnvelope>>(params?: ListStaffUsageJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStaffUsageJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaffUsageJobs>>> = ({ signal }) => listStaffUsageJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStaffUsageJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listStaffUsageJobs>>>
export type ListStaffUsageJobsQueryError = ErrorType<ErrorEnvelope>


export function useListStaffUsageJobs<TData = Awaited<ReturnType<typeof listStaffUsageJobs>>, TError = ErrorType<ErrorEnvelope>>(
 params: undefined |  ListStaffUsageJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffUsageJobs>>,
          TError,
          Awaited<ReturnType<typeof listStaffUsageJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffUsageJobs<TData = Awaited<ReturnType<typeof listStaffUsageJobs>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStaffUsageJobs>>,
          TError,
          Awaited<ReturnType<typeof listStaffUsageJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStaffUsageJobs<TData = Awaited<ReturnType<typeof listStaffUsageJobs>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Staff Usage Jobs
 */

export function useListStaffUsageJobs<TData = Awaited<ReturnType<typeof listStaffUsageJobs>>, TError = ErrorType<ErrorEnvelope>>(
 params?: ListStaffUsageJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStaffUsageJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStaffUsageJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getFindStaffUserUrl = (params: FindStaffUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/staff/users?${stringifiedParams}` : `/api/v1/staff/users`
}

/**
 * The user with this email, tombstoned or not, and their teams; 404 when none.
 * @summary Find Staff User
 */
export const findStaffUser = async (params: FindStaffUserParams, options?: Parameters<typeof apiRequest>[1]): Promise<StaffUser> => {

  return apiRequest<StaffUser>(getFindStaffUserUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindStaffUserQueryKey = (params?: FindStaffUserParams,) => {
    return [
    `/api/v1/staff/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindStaffUserQueryOptions = <TData = Awaited<ReturnType<typeof findStaffUser>>, TError = ErrorType<ErrorEnvelope>>(params: FindStaffUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindStaffUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findStaffUser>>> = ({ signal }) => findStaffUser(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindStaffUserQueryResult = NonNullable<Awaited<ReturnType<typeof findStaffUser>>>
export type FindStaffUserQueryError = ErrorType<ErrorEnvelope>


export function useFindStaffUser<TData = Awaited<ReturnType<typeof findStaffUser>>, TError = ErrorType<ErrorEnvelope>>(
 params: FindStaffUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findStaffUser>>,
          TError,
          Awaited<ReturnType<typeof findStaffUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindStaffUser<TData = Awaited<ReturnType<typeof findStaffUser>>, TError = ErrorType<ErrorEnvelope>>(
 params: FindStaffUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findStaffUser>>,
          TError,
          Awaited<ReturnType<typeof findStaffUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindStaffUser<TData = Awaited<ReturnType<typeof findStaffUser>>, TError = ErrorType<ErrorEnvelope>>(
 params: FindStaffUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find Staff User
 */

export function useFindStaffUser<TData = Awaited<ReturnType<typeof findStaffUser>>, TError = ErrorType<ErrorEnvelope>>(
 params: FindStaffUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findStaffUser>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindStaffUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeleteStaffUserUrl = (userId: string,) => {




  return `/api/v1/staff/users/${userId}`
}

/**
 * Delete a user: memberships, sessions and tokens go, the row is tombstoned and the
 * email can never sign up again. 409 for staff and for the owner of a live team.
 * @summary Delete Staff User
 */
export const deleteStaffUser = async (userId: string,
    headers: DeleteStaffUserHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<void>(getDeleteStaffUserUrl(userId),
  {
    ...options,
    method: 'DELETE',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getDeleteStaffUserMutationKey = () => ['deleteStaffUser'] as const;

export const getDeleteStaffUserMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStaffUser>>, TError,DeleteStaffUserMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStaffUser>>, TError,DeleteStaffUserMutationVariables, TContext> => {

const mutationKey = getDeleteStaffUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStaffUser>>, DeleteStaffUserMutationVariables> = (props) => {
          const {userId,headers} = props ?? {};

          return  deleteStaffUser(userId,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStaffUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStaffUser>>>

    export type DeleteStaffUserMutationError = ErrorType<ErrorEnvelope>
    export type DeleteStaffUserMutationVariables = {userId: string;headers: DeleteStaffUserHeaders}

    /**
 * @summary Delete Staff User
 */
export const useDeleteStaffUser = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStaffUser>>, TError,DeleteStaffUserMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStaffUser>>,
        TError,
        DeleteStaffUserMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteStaffUserMutationOptions(options), queryClient);
    }
